import { AppShell } from '@/shared/components/layout';
import { LandingHeader } from '../components/LandingHeader';
import { LandingHero } from '../components/LandingHero';
import { LandingSocialProof } from '../components/LandingSocialProof';
import { LandingShowcase } from '../components/LandingShowcase';
import { LandingHowItWorks } from '../components/LandingHowItWorks';
import { LandingModules } from '../components/LandingModules';
import { LandingCaseStudy } from '../components/LandingCaseStudy';
import { LandingPricing } from '../components/LandingPricing';
import { LandingFaq } from '../components/LandingFaq';
import { LandingLeadForm } from '../components/LandingLeadForm';
import { LandingFooter } from '../components/LandingFooter';
import { LANDING_JSON_LD } from '../../domain/landingContent';

/** Landing page B2B pública (rota "/"). */
export default function LandingPage() {
  return (
    <AppShell ambient>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(LANDING_JSON_LD.organization) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(LANDING_JSON_LD.software) }}
      />

      <LandingHeader />

      <main className="relative z-10 flex-1">
        <LandingHero />
        <LandingSocialProof />
        <LandingShowcase />
        <LandingHowItWorks />
        <LandingModules />
        <LandingCaseStudy />
        <LandingPricing />
        <LandingFaq />
        <LandingLeadForm />
      </main>

      <LandingFooter />
    </AppShell>
  );
}
